import { render, staticRenderFns } from "./correlate-mobile.vue?vue&type=template&id=03448afb&scoped=true&"
import script from "./correlate-mobile.vue?vue&type=script&lang=js&"
export * from "./correlate-mobile.vue?vue&type=script&lang=js&"
import style0 from "./correlate-mobile.vue?vue&type=style&index=0&id=03448afb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03448afb",
  null
  
)

export default component.exports